import _ from "lodash";

const questionsSlide = () => {
    const $slider = $(".questions-slide-wrap .slide")
    const $answerSlider = $(".answers-slide");
    window.$slider = $slider;
    window.$answerSlider = $answerSlider;

    const loadClass = (startSlide, slick) => {
        let start = startSlide;
        let end = start + slick.options.slidesToShow;//Math.min(start + slick.options.slidesToShow, slick.slideCount);
        let startSub = -2;
        $(`.questions-slide-wrap .slide .slick-slide`).removeClass(['sub-2', 'sub-1', 'sub-0', 'sub--2', 'sub--1']);
        for (let i = start; i < end; i++) {
            //    console.log(i, $(`.questions-slide-wrap .slide .slick-slide[data-slick-index=${i}]`))
            $(`.questions-slide-wrap .slide .slick-slide[data-slick-index=${i}]`).addClass(`sub-${startSub}`)
            $(`.questions-slide-wrap .slide .slick-slide[data-slick-index=${slick.slideCount + i}]`).addClass(`sub-${startSub}`)
            $(`.questions-slide-wrap .slide .slick-slide[data-slick-index=${i - slick.slideCount}]`).addClass(`sub-${startSub}`)

            startSub++;
        }
        if (startSlide == slick.slideCount - 1) {
            let currentY = parseInt($slider.find(".slick-track").css("transform").split(',')[5])
            let itemHeight = $(`.questions-slide-wrap .slide .slick-slide.sub-0`).height();
            // $slider.find(".slick-track").css({
            //     transform: `translate3d(0px, ${currentY - itemHeight}px, 0px)`,
            //    // transition: "all 0.5s ease" 
            // })
        }
    }
    const resetIndex = (slick) => {
        let count = slick.slideCount - 4; //trừ 4 cái trống
        let index = Math.ceil(count / 2) - 1; //tìm cái ở giữa
        $slider.slick("slickGoTo", index)
        $answerSlider.slick("slickGoTo", index + 2)

    }
    const afterInit = (slick) => {
        $(".question-group").show()
        setTimeout(async () => {
            resetIndex(slick);
            loadClass(slick.currentSlide, slick);
            await new Promise(r => setTimeout(r, 500))

            let height = $slider.outerHeight();
            $(".question-group").height(height);
            aos.refresh(); //tính toán lại tọa độ các animation
            initCustomScroll(".custom-scroll-ans", false)
        }, 100)
    }
    $slider.on('init', function (event, slick, currentSlide, nextSlide) {
        afterInit(slick);


    });
    $answerSlider.on('init', function (event, slick, currentSlide, nextSlide) {
        $(".answer-group").show()
        aos.refresh(); //tính toán lại tọa độ các animation
    });

    $(window).on("resize", function () {
        afterInit($slider.get(0).slick);
    })

    const init = ({ infinite } = { infinite: true }) => {
        $slider.slick({
            dots: false,
            speed: 500,
            slidesToShow: 5,
            //centerPadding: "50%",
            //slidesToScroll: 1,
            draggable: false,
            swipeToSlide: true,
            vertical: true,
            verticalSwiping: false,
            centerMode: false,
            arrows: false,
            adaptiveHeight: true,
            initialSlide: 0,
            autoplay: true,
            autoplaySpeed: 2500,
            infinite: infinite,
            mobileFirst: true,
            // cssEase: 'linear',
            //useTransform: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 5
                    }
                },
            ]
        })
        $answerSlider.slick({
            speed: 500,
            slidesToShow: 1,
            infinite: infinite,
            dots: false,
            arrows: false,
            draggable: false,
            initialSlide: 0,
            fade: true,
            adaptiveHeight: true
        })
    }

    $slider.on('swipe', function (event, slick, direction) {
        // left
    });

    $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        loadClass(nextSlide, slick)

    });

    $slider.on('afterChange', function (event, slick, currentSlide) {
        $answerSlider.slick("slickGoTo", currentSlide + 2)
        // const _last = slick.slideCount - slick.options.slidesToShow

        // if (_last === currentSlide) {
        //     //$slider.slick('slickPause')
        //     $slider.slick('slickGoTo', 0, false)
        // }

    });

    $slider.on("click", ".slick-slide", async function () {
        let slideIndex = $(this).data("slick-index");

        //if(slideIndex )
        let currentSlide = $slider.slick("slickCurrentSlide");
        let targetSlide = slideIndex - 2;
        let countSlide = Math.abs(currentSlide - targetSlide);
        let event = "slickNext"
        if (targetSlide < currentSlide) event = "slickPrev";

        for (let i = 0; i < countSlide; i++) {
            $slider.slick(event)
            await new Promise(r => setTimeout(r, 500))
        }

    })
    let lastClick = 0
    $(".questions-slide-wrap .slide-btn").on("click", function () {
        if (Date.now() - lastClick < 300) return
        lastClick = Date.now()
        if ($(this).hasClass("prev")) $slider.slick("slickPrev");
        else $slider.slick("slickNext");
    })

    //onHold
    let timeoutHold = 0;
    let changeSetting = false;
    $(".questions-slide-wrap .slide-btn").on('mousedown', function () {

        timeoutHold = setInterval(() => {
            if (!changeSetting) {
                $slider.slick("slickSetOption", "speed", 300, false);
                changeSetting = true
            }
            $(this).click()
        }, 100);
    }).on('mouseup mouseleave', function () {
        clearTimeout(timeoutHold);
        timeoutHold = 0;
        if (changeSetting) {
            $slider.slick("slickSetOption", "speed", 500, false);
            changeSetting = false;
        }
    });

    //xử lý filter
    const $sliderCloneBackup = $slider.clone(true, true)
    $sliderCloneBackup.find(".slick-cloned").remove();
    let $sliderClone = $sliderCloneBackup.clone(true, true);
    const $answerSliderCloneBackup = $answerSlider.clone(true, true);
    $answerSliderCloneBackup.find(".slick-cloned").remove();
    let $answerSliderClone = $answerSliderCloneBackup.clone(true, true);
    const onSearch = () => {
        const searchValue = $(".question-search").find("input").val().toLocaleLowerCase();

        $slider.slick('unslick'); // Remove slick
        $answerSlider.slick('unslick');
        $slider.empty(); // Remove elements
        $answerSlider.empty();


        let result = [];
        let resultAns = [];
        //let regex = new RegExp(encodeURIComponent(searchValue).replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), "gi");
        const $answerItems = $answerSliderClone.find(".answer-item");
        $sliderClone.find('.slide-item').each(function (index, element) {
            const content = $(this).find(".item").text();
            if (!searchValue) { // trường hợp lấy tât cả dữ liệu
                if (content) {
                    result.push($(this));
                    resultAns.push($answerItems.get(index))
                }
            }//trường hợp search
            else if (!content || content.toLocaleLowerCase().indexOf(searchValue) != -1) {
                result.push($(this));
                resultAns.push($answerItems.get(index))
            }
        })
        if (searchValue && $(window).width() >= 992 && $(window).width() < 1440) {
            result.pop()
            resultAns.pop()
        }

        $slider.append(result);
        $answerSlider.append(resultAns)


        $sliderClone = $sliderCloneBackup.clone(true, true);
        $answerSliderClone = $answerSliderCloneBackup.clone(true, true);
        // Slick slider init
        init({
            infinite: searchValue ? false : true
        });
        return false;
    }
    $(".question-search").on("submit", function () {
        return onSearch()
    })

    $(".question-search .fa-search").on("click", function () {
        $(".question-search").submit()
    })

    $(".search-input input").on("input", _.debounce(() => {
        onSearch()
    }, 300))
    init();
    onSearch()

}

export default questionsSlide